<!--
 * @Author: JakeChiu
 * @Emaiil: 3289011@qq.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2022-01-20 16:30:27
 * @LastEditTime: 2026-01-22 16:20:47
 * @LastEditors: Please set LastEditors
 * @Description: JakeChiu in HX at Do not edit
 * @FilePath: \visualh5\src\components\loginfordy.vue
-->
<template>
  <div class="loginfordy">
    <loadJs @loadJsOk="onLoadSdked"
    ></loadJs>
  </div>
</template>

<script>
const loadJs= {
  // 渲染到页面
    render(h) {
        const _this = this;
        var src = (location.host.indexOf('test')>-1?'https://testreg.homeway.com.cn/js/module/dy_login_1.1.js':'https://reg.homeway.com.cn/js/module/dy_login_1.0.js')+'?d='+new Date().toDateString().replace(/ /ig,'')+'&____stamp';
        return h('script', {
            attrs: { type: 'text/javascript', src},
            on: {
                load: function () {
                  _this.$emit('loadJsOk')
                }
            }
        });
    }
};
export default {
  name: "loginfordy",
  /**
   * @description: 本地存储
   * @param {*}
   * @return {*}
   */
  data() {
    return {
      id: 0,
      invoketoken: 0,
      modeid: 0,
      modeitem: null,
      cont:'',
      paying:true,
      getstatuenum:0
    };
  },
  computed: {
      /**
       * @description: 父级
       * @return {*}
       */        
      parent(){return this.$parent}
  },
  watch: {},
  components: {
        loadJs
    },
  methods: {
    /**
     * @description: 获取登录信息
     * @param {*} _data
     * @return {*}
     */
     onLoadSdked(){
      console.log('load sdkjs');
     },
    /**
     * @description: 外部启动
     * @param {*} _data
     * @return {*}
     */
    init(_data,callback) {
      const _this=this;
      //const url = _data.linkopt==1&&_data.linktype == 2?_data.href:location.href;
      //202470812 因不能传递clickid 所以不能直接传给抖音支付地址
      let url = location.href;
      // 如果登录完成，增加jump=1 20241025153555 frome dazhi
      url = url.indexOf('?')>-1?`${url}&jump=1`:`${url}?jump=1`
      setTimeout(function(){
        // 非快捷支付不用刷新页面，直接跳转购买地址
        window.dyModule.login(url,function(_res){
          // 未授权成功
          if(_res.code!=1){
            // 小于1元的订单取消授权需要弹出手机号绑定
            if(_this.parent.isMicroPayent){
              _this.parent.$refs.micropaymentcom.popupLogin().then(()=>{
                if(callback){
                  callback();
                }else{
                  _this.parent.evenclick(_this.parent.modelist[0], false);
                }
              })
            }
            // 上报埋点
            _this._sendTrack("click_douyin_auth", {
              auth_result:'手机号授权',
              page_title:'营销课落地页',
              page_name: "投放页面",
              from_source: "h5",
              redirect_url: location.href,
              product_id: _data.groupId,
              partner_id:_this.parent.markeyPage.partnerId,
              campaign_id:_this.parent.id,
              action_result:"Failure",
              url:location.href
            });
          }
        });
      },300)
    },
  }
};
</script>
